import { Stack, TextField, Typography, debounce } from "@mui/material";
import React, { ComponentProps, useCallback, useEffect, useState } from "react";

import { IAppointmentNoteFieldProps } from "./AppointmentNoteCard";

export interface IBookingWizardCustomNoteFieldConfig {
  noteCharacterLimit: number;
}

export const classNames = {
  textField: "AppointmentNoteField_text-field"
};

/** A debounced field which allows users to input custom note content for the appointment note. */
const AppointmentNoteField: React.FC<IAppointmentNoteFieldProps & IBookingWizardCustomNoteFieldConfig> = ({
  value,
  onChange,
  noteCharacterLimit,
  ...rest
}) => {
  const [localValue, setLocalValue] = useState("");
  useEffect(() => setLocalValue(value), [value]);
  const debouncedOnChange = useCallback(
    debounce((value: string) => onChange(value), 400),
    []
  );
  const handleChange: ComponentProps<typeof TextField>["onChange"] = event => {
    if (event.target.value.length > noteCharacterLimit) return;
    setLocalValue(event.target.value);
    debouncedOnChange(event.target.value);
  };
  const remainingCharacters = noteCharacterLimit - value.length;

  return (
    <Stack spacing={1}>
      <TextField
        {...rest}
        label="Additional Notes"
        fullWidth
        multiline
        minRows={6}
        maxRows={9}
        value={localValue}
        className={classNames.textField}
        onChange={handleChange}
        variant="outlined"
        inputProps={{ maxLength: noteCharacterLimit }}
      />
      <Typography variant="caption" color={!remainingCharacters ? "error" : undefined}>
        Characters Remaining: {remainingCharacters}
      </Typography>
    </Stack>
  );
};

export default AppointmentNoteField;
